import React from 'react';
import Dropdown from '../components/Dropdown';
import { WaiverAirline } from '../types/waiver';

interface AirlineSelectorProps {
  id: string;
  airlines: WaiverAirline[];
  value?: string;
  onChange: (value: string | number | readonly string[] | undefined) => void
};

const AirlineSelector = (props: AirlineSelectorProps) => {
  const airlineOptions = [
    { text: 'All airlines', value: '' },
    ...props.airlines.map(airline => ({
      text: airline.code,
      value: airline.code,
    })),
  ];
  return (
    <Dropdown
      id={props.id}
      onChange={props.onChange}
      value={props.value}
      options={airlineOptions}
    />
  );
};

export default AirlineSelector;